import type { AgentModelProvider } from './enums';

export const DEFAULT_AGENT_MODEL_ID = 'claude-opus-4-6';

export interface AgentModelDescriptor {
  id: string;
  provider: AgentModelProvider;
  label: string;
  supportsStreaming: boolean;
  supportsTools: boolean;
}
